import { IsEnum, IsObject } from "class-validator";
import { Environment } from "../models/models";

export enum SurveyStatus {
  sent = "sent",
  completed = "completed",
  pending = "pending"
}

export type Answer = {
  question: string;
  response: string | string[];
};

export type Anwsers = Record<string, Answer>;

export class SurveyDto {
  @IsObject()
  answers!: Anwsers;

  @IsEnum(SurveyStatus)
  status!: SurveyStatus;
}

type SurveyName = "Security due Diligence";

const formIds: Record<Environment, Record<SurveyName, string>> = {
  development: {
    "Security due Diligence": "1DvApg8hznF2lRd8fb8Ez_MDBUR-qSchAHmAkIGVSnKU"
  },
  staging: {
    "Security due Diligence": "1DvApg8hznF2lRd8fb8Ez_MDBUR-qSchAHmAkIGVSnKU"
  },
  production: {
    "Security due Diligence": "1IBV8J-kgdUdo1gHzvULGILCgt-EPCZYJ9TvPaw9z3fI"
  }
};

export const getFormId = (environment: Environment, surveyName: SurveyName) => formIds[environment][surveyName];
